export const ASEData = [
  {
    aseName: "Akshit Bhalla",
    aseProject: "Digital",
    aseMarket: "CIO",
    aseImage: "images/testimonial/AkshitBhalla.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_43xqm3wj/uiConfId/27188232/st/0",
  },
  {
    aseName: "Arvind Kumar",
    aseProject: "Best Buy Inc",
    aseMarket: "NA",
    aseImage: "images/testimonial/ArvindKumar.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_f9l0154o/uiConfId/27188232/st/0",
  },
  {
    aseName: "Basavaraj",
    aseProject: "Beam",
    aseMarket: "NA",
    aseImage: "images/testimonial/Basavaraj.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_2p3x2e9l/uiConfId/27188232/st/0",
  },
  {
    aseName: "Darshan Neman",
    aseProject: "Exelon IT",
    aseMarket: "NA",
    aseImage: "images/testimonial/DarshanNeman.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_3uiqw8zf/uiConfId/27188232/st/0",
  },
  {
    aseName: "Dinesh Cherukuru",
    aseProject: "Unilever Frontier Devops",
    aseMarket: "Products & Platforms",
    aseImage: "images/testimonial/DineshCherukuru.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_9r7ywuld/uiConfId/27188232/st/0",
  },
  {
    aseName: "Gopi Kancharagunta",
    aseProject: "Google Store Testing",
    aseMarket: "West",
    aseImage: "images/testimonial/GopiKancharagunta.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_aua9tkwt/uiConfId/27188232/st/0",
  },
  {
    aseName: "Grace Pamei",
    aseProject: "DGTL FED STUDIO",
    aseMarket: "Song",
    aseImage: "images/testimonial/GracePamei.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_tauof4tz/uiConfId/27188232/st/0",
  },
  {
    aseName: "J Kalpeshkumar Shah",
    aseProject: "CCB CC Simplification Of Cashflow360",
    aseMarket: "Northeast",
    aseImage: "images/testimonial/JKalpeshkumarShah.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_75b5lobd/uiConfId/27188232/st/0",
  },
  {
    aseName: "Jeevanandham Kotti",
    aseProject: "Risk Tech QE",
    aseMarket: "South",
    aseImage: "images/testimonial/JeevanandhamKotti.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_c8kual3v/uiConfId/27188232/st/0",
  },
  {
    aseName: "Mahalakshmi Arumugam",
    aseProject: "Speakeasy FD and TICo",
    aseMarket: "West",
    aseImage: "images/testimonial/MahalakshmiArumugam.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_gmh1bew4/uiConfId/27188232/st/0",
  },
  {
    aseName: "Maturi Dronachary",
    aseProject: "CCB ICAF",
    aseMarket: "Northeast",
    aseImage: "images/testimonial/MaturiDronachary.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_okvejqon/uiConfId/27188232/st/0",
  },
  {
    aseName: "P Devendra Sharma",
    aseProject: "Google Store Testing",
    aseMarket: "West",
    aseImage: "images/testimonial/PDevendraSharma.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_joe8xjje/uiConfId/27188232/st/0",
  },
  {
    aseName: "Pushkar Arvind Dighe",
    aseProject: "SF WD CIO Global IT",
    aseMarket: "AMS EIT Workday",
    aseImage: "images/testimonial/PushkarArvindDighe.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_vds0ncxv/uiConfId/27188232/st/0",
  },
  {
    aseName: "Radha",
    aseProject: "ENOVIS",
    aseMarket: "NA",
    aseImage: "images/testimonial/Radha.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_759k9853/uiConfId/27188232/st/0",
  },
  {
    aseName: "Rasagna Konduri",
    aseProject: "Risk Tech QE",
    aseMarket: "South",
    aseImage: "images/testimonial/RasagnaKonduri.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_tx7my8ik/uiConfId/27188232/st/0",
  },
  {
    aseName: "Shreyagupta",
    aseProject: "Mccormick",
    aseMarket: "NorthAmerica",
    aseImage: "images/testimonial/Shreyagupta.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_vscua95t/uiConfId/27188232/st/0",
  },
  {
    aseName: "Kalaivani",
    aseProject: "Singtel DFF",
    aseMarket: "GM",
    aseImage: "images/testimonial/Kalaivani.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_lp0xjh6s/uiConfId/27188232/st/0",
  },
  {
    aseName: "Kavitha Kothapalli",
    aseProject: "MyWizardICI",
    aseMarket: "AAME",
    aseImage: "images/testimonial/KavithaKothapalli.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_m4mlyf2u/uiConfId/27188232/st/0",
  },
  {
    aseName: "Milana K R",
    aseProject: "BMS Value&Testing",
    aseMarket: "NA",
    aseImage: "images/testimonial/MilanaKR.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_z06m2jc5/uiConfId/27188232/st/0",
  },
  {
    aseName: "Mohammad Bilal",
    aseProject: "One Digital Platform",
    aseMarket: "CMO",
    aseImage: "images/testimonial/MohammadBilal.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_5zi2kr1u/uiConfId/27188232/st/0",
  },
  {
    aseName: "Nagireddy Shivasai",
    aseProject: "Avanade Siemens",
    aseMarket: "SI",
    aseImage: "images/testimonial/NagireddyShivasai.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_6lyftg1a/uiConfId/27188232/st/0",
  },
  {
    aseName: "Nishant",
    aseProject: "Jaguar",
    aseMarket: "EuropeMarket",
    aseImage: "images/testimonial/Nishant.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_02scjnme/uiConfId/27188232/st/0",
  },
  {
    aseName: "Priyanshu Paul",
    aseProject: "BMW Financial Services",
    aseMarket: "NA",
    aseImage: "images/testimonial/PriyanshuPaul.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_i334pbzp/uiConfId/27188232/st/0",
  },
  {
    aseName: "Pushpalatha",
    aseProject: "Enovis",
    aseMarket: "NA",
    aseImage: "images/testimonial/Pushpalatha.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_0znsfy1d/uiConfId/27188232/st/0",
  },
  {
    aseName: "Ritesh Raut",
    aseProject: "CCP NPP Communities",
    aseMarket: "NA",
    aseImage: "images/testimonial/RiteshRaut.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_f45lxvoq/uiConfId/27188232/st/0",
  },
  {
    aseName: "Rithvikreddy",
    aseProject: "Hersheys",
    aseMarket: "Cloud First",
    aseImage: "images/testimonial/Rithvikreddy.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_f2ibetr2/uiConfId/27188232/st/0",
  },
  {
    aseName: "Rohith Pillai",
    aseProject: "Sedgewik",
    aseMarket: "NA",
    aseImage: "images/testimonial/RohithPillai.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_zopup647/uiConfId/27188232/st/0",
  },
  {
    aseName: "Sayani Bhattacharya",
    aseProject: "Coles",
    aseMarket: "GM",
    aseImage: "images/testimonial/SayaniBhattacharya.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_y5hdkafg/uiConfId/27188232/st/0",
  },
  {
    aseName: "Shubham Pujari",
    aseProject: "BMS",
    aseMarket: "NA",
    aseImage: "images/testimonial/ShubhamPujari.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_drfpxx7s/uiConfId/27188232/st/0",
  },
  {
    aseName: "Siddhali Sagvekar",
    aseProject: "Signet Jewelers",
    aseMarket: "NA",
    aseImage: "images/testimonial/SiddhaliSagvekar.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_rbftcdl0/uiConfId/27188232/st/0",
  },
  {
    aseName: "Srilekha Bayyapu",
    aseProject: "OGE Corp",
    aseMarket: "NA",
    aseImage: "images/testimonial/SrilekhaBayyapu.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_2co8r5ii/uiConfId/27188232/st/0",
  },
  {
    aseName: "Sumit Manoj Singh",
    aseProject: "McDonalds",
    aseMarket: "NA",
    aseImage: "images/testimonial/SumitManojSingh.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_1n3zpw2y/uiConfId/27188232/st/0",
  },
  {
    aseName: "Surya Munusamy",
    aseProject: "Best Buy AM",
    aseMarket: "NA",
    aseImage: "images/testimonial/SuryaMunusamy.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_phoviogy/uiConfId/27188232/st/0",
  },
  {
    aseName: "Syeda Farheen Quadri",
    aseProject: "Nissan SMAF",
    aseMarket: "EU",
    aseImage: "images/testimonial/SyedaFarheenQuadri.png",
    aseVideo:
      "https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_itgrjibe/uiConfId/27188232/st/0",
  },
];
